import { Button, Modal, HelpBlock, FlexboxGrid } from 'rsuite';

import PropTypes from 'prop-types';
import React from 'react';
import { startCase, isEmpty } from 'lodash';
import { format } from 'date-fns';
import { compose } from 'redux';
import TimelineComponent from 'components/Timeline';
import ImageGallery from 'components/ImageGallery';

export function TicketInfoModal({ show, setClose, ticket }) {
  const images = ticket?.attachments !== undefined && JSON.parse(ticket?.attachments);
  let filteredImageTypes = [];
  if (images) {
    filteredImageTypes = images.filter(function(a) {
      const splitStr = a.split('.');
      const imageType = splitStr[splitStr.length - 1];
      return imageType === 'jpg' || imageType === 'jpeg' || imageType === 'png';
    });
  }
  const getTimeline = () => {
    const items = [];
    const timelineObj = ticket?.timeline !== undefined && JSON.parse(ticket?.timeline);
    if (timelineObj) {
      timelineObj.map(t => {
        items.push({
          date: format(new Date(t.createdAt), 'MMM dd, yyyy'),
          ...(t.body && {
            name: (
              <div style={{ borderBottom: '1px solid #d9d9d9', marginBottom: '20px' }}>Author: {t.author.name}</div>
            ),
          }),
          text: <div>{t.body ? t.body : startCase(t.newValue)}</div>,
          icon: t.body ? 'commenting-o' : 'ticket',
        });
      });
    }
    return items;
  };
  return (
    <Modal backdrop={true} show={show} onHide={() => setClose(false)} size="md">
      <Modal.Body>
        <HelpBlock> Ticket# </HelpBlock>
        <p>{ticket?.zendeskId}</p>
        <HelpBlock> Title: </HelpBlock>
        <p>{ticket?.briefDescription}</p>
        <FlexboxGrid>
          <FlexboxGrid.Item colspan={18}>
            <HelpBlock> History </HelpBlock>
            <TimelineComponent style={{ paddingRight: '20px' }} items={getTimeline()} />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item colspan={6}>
            {!isEmpty(images) && (
              <>
                <HelpBlock> Images </HelpBlock>
                <ImageGallery
                  images={filteredImageTypes.map(i => ({
                    src: i, // filter
                  }))}
                />
              </>
            )}
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Modal.Body>
      <Modal.Footer style={{ textAlign: 'center', marginTop: '1em' }}>
        <Button
          onClick={() => {
            setClose(false);
          }}
          size="xs"
          appearance="ghost">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

TicketInfoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setClose: PropTypes.func.isRequired,
};

export default compose(TicketInfoModal);
